import { render, staticRenderFns } from "./MyButton.vue?vue&type=template&id=075098cd&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"
import style0 from "./MyButton.vue?vue&type=style&index=0&id=075098cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075098cd",
  null
  
)

export default component.exports